export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjRlYzMyMjk4LTgyYWYtNDg2Ny04NmI4LWVlNzRmY2VhMTgzMiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.xkLv/2UWKKtmXv/E35ppBbzMpowcxBT7gAdWQhW7tpH6o4u1sUUPIIgyayIwzx+8xwvmqxxdojWoFldaFviey877WQQE+vnJiU4wCwGIO49OmOTWypG5nnSmMGRPOl3xLfACTA==';
